// extracted by mini-css-extract-plugin
export default {"kcbService":"kcbService_kcbService__S4skN"};